module.exports = __webpack_public_path__ + "media/emojis/neutral-7f1b1598.svg";